module.exports = __webpack_public_path__ + "img/imgZXGH(6).b827222f.png";